import PropTypes from 'prop-types';

export const LocationPropType = PropTypes.shape({
  id: PropTypes.number,
  locationName: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
});
